import React, { useContext } from 'react';
import ProductHeaderDesktop from './components/header-desktop';
import ProductHeaderMobile from './components/header-mobile';
import { ProductHeaderProps } from './types';

import { ViewportContext } from '../../../../components/viewport';

const ProductHeader = React.memo((props: ProductHeaderProps) => {
  const { isMobile } = useContext(ViewportContext);

  return (
    <>
      {isMobile ? (
        <ProductHeaderMobile {...props} />
      ) : (
        <ProductHeaderDesktop {...props} />
      )}
    </>
  );
});

export default ProductHeader;
